import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Alert, Row, Col, Container, Badge, Button } from "reactstrap";
import LoadingSpinner from "../Components/Common/LoadingSpinner";
import PaymentForm from "../Components/Common/PaymentForm";
import OrderSummary from "../Components/Common/OrderSummary";
import OrderSubmissionModal from "../Components/Common/OrderSubmissionModal";
import MainPage from "../Components/Shared/MainPage";
import { CheckoutCreditCardApi, ImageUrls } from "../Code/Data";
import { scrollToElement } from "../Code/Utilities";

function expirationDateIsValid(creditData) {
  let today = new Date();
  let someday = new Date(
    `20${creditData.ExpirationDateYear}-${creditData.ExpirationDateMonth}-01`
  );
  return someday > today;
}

function checkLuhn(n) {
  let c,
    s = 0,
    m = 0,
    l = n.length;
  while (l--) {
    c = parseInt(n.charAt(l), 10) << m;
    s += c - (c > 9) * 9;
    m ^= 1;
  }
  return s % 10 === 0 && s > 0;
}

export default class CreditCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditData: null,
      personalInfo: null,
      errMsg: null,
      loading: false,
      showSubmitButton: true,
    };

    this.handleCreditChange = this.handleCreditChange.bind(this);
    this.handlePersonalInfoChange = this.handlePersonalInfoChange.bind(this);
    this.getValidationMessage = this.getValidationMessage.bind(this);
    this.submitOrder = this.submitOrder.bind(this);
  }

  handlePersonalInfoChange(personalInfo) {
    this.setState({ personalInfo });
  }

  handleCreditChange(creditData) {
    this.setState({ creditData });
  }

  getValidationMessage(creditData) {
    let validationMessage = "";
    if (!creditData) {
      validationMessage +=
        "Please fully fill out all the fields before submitting.";
    } else if (!creditData.Address) {
      validationMessage +=
        "Please fully fill out the address before submitting.";
    } else if (!creditData.City) {
      validationMessage +=
        "Please fill out the address city before submitting.";
    } else if (!creditData.State) {
      validationMessage +=
        "Please fill out the address state before submitting.";
    } else if (!creditData.Zip) {
      validationMessage += "Please fill out the zip code before submitting.";
    } else if (creditData.ExpirationDateMonth.length !== 2) {
      validationMessage +=
        "Please fill out the expiration month correctly before submitting.";
    } else if (creditData.ExpirationDateYear.length !== 2) {
      validationMessage +=
        "Please fill out the expiration year correctly before submitting.";
    } else if (!expirationDateIsValid(creditData)) {
      validationMessage +=
        "Please fill out the expiration date correctly before submitting.";
    } else if (
      creditData.CreditCardNumber.length < 12 ||
      creditData.CreditCardNumber.length > 19
    ) {
      validationMessage +=
        "Please fill out the credit card number correctly before submitting.";
    } else if (!checkLuhn(creditData.CreditCardNumber)) {
      validationMessage +=
        "Please fill out the credit card number correctly before submitting.";
    } else if ([3, 4].indexOf(creditData.CVV.length) === -1) {
      validationMessage +=
        "Please fill out the CVV correctly before submitting.";
    }
    return validationMessage;
  }

  async submitOrder() {
    let { shoppingCart } = this.props;
    if (!shoppingCart) {
      this.setState({ errMsg: "Cart does not exist" });
      return;
    }

    let { creditData } = this.state;
    const validationMessage = this.getValidationMessage(creditData);
    if (validationMessage) {
      this.setState({
        errMsg: validationMessage,
      });
      setTimeout(() => scrollToElement(".alert-danger", true, 0), 500);
      return;
    }

    this.setState({ errMsg: null, showSubmitButton: false });
    let request = creditData;

    console.log("PAYING", request);

    let response = await CheckoutCreditCardApi(request);
    console.log("CREDIT CARD RESPONSE", response);
    if (response.Succeeded) {
      let hasRedemptions = shoppingCart.Items.reduce(
        (acc, item) => acc || item.Type === "Redemption Codes",
        false
      );
      window.location.href = `https://${window.location.host}/Purchase/OrderComplete?purchaseId=${response.PurchaseId}&hasRedemptions=${hasRedemptions}`;
    } else {
      this.setState({ errMsg: response.ErrorMessage || response, showSubmitButton: true });
      setTimeout(
        () =>
          response.ErrorMessage && scrollToElement(".alert-danger", true, 0),
        500
      );
    }
  }

  render() {
    const { shoppingCart } = this.props;

    if (!shoppingCart || !shoppingCart.Items.length) {
      return <MainPage title="Your shopping cart is empty" />;
    }

    console.log("CART", this.props, this.state);
    const { loading, errMsg, showSubmitButton } = this.state;

    if (loading) {
      return <LoadingSpinner />;
    } else if (!!errMsg && !shoppingCart) {
      return <MainPage title={errMsg} />;
    }

    return (
      <Container className="cart-page">
        <Row>
          <Col md={8} className="left-pane">
            <Container>
              <Row>
                <h2>Checkout</h2>
              </Row>
              {errMsg && (
                <Row>
                  <Alert color="danger">{errMsg}</Alert>
                </Row>
              )}
              <Row className="checkout-flow">
                <Col>
                  <PaymentForm onChange={this.handleCreditChange} />
                </Col>
              </Row>
              <Row>
                <h3>Review & Submit Order</h3>
              </Row>
              <Row>
                {shoppingCart && (
                  <Container className="cart-items">
                    {shoppingCart.Items.map(item => (
                      <Row key={item.PaidItemId}>
                        <Col md={2}>
                          {item.CardImageUrl ||
                          ImageUrls[item.ShoppingCartItemTypeId] ? (
                            <img
                              className="img-fluid"
                              src={
                                item.CardImageUrl ||
                                ImageUrls[item.ShoppingCartItemTypeId]
                              }
                              alt={item.Type}
                            />
                          ) : (
                            <div className="cart-image-spacer"></div>
                          )}
                        </Col>
                        <Col md={6}>
                          <h3>{item.Type}</h3>
                          <p>{item.ShortDescription}</p>
                          <p>{item.Description}</p>
                          <p>
                            {item.IsBulkHiddenAmount
                              ? "Cost per code"
                              : "Denomination"}
                            : ${item.Denomination.toFixed(2)}
                          </p>
                          {item.canEdit && (
                            <p>
                              <a href={item.editUrl}>Edit Order</a>
                            </p>
                          )}
                        </Col>
                        <Col md={2}>
                          <p>${item.TotalForCards.toFixed(2)}</p>
                        </Col>
                        <Col md={2}>
                          <Badge className="quantity-badge">
                            {item.Quantity}
                          </Badge>
                        </Col>
                      </Row>
                    ))}
                  </Container>
                )}
              </Row>
              <Row>
                {showSubmitButton && (
                  <Button color="primary" onClick={this.submitOrder}>
                    Submit Order
                  </Button>
                )}
              </Row>
            </Container>
          </Col>
          <Col md={4} className="right-pane">
            <OrderSummary shoppingCart={shoppingCart} />
            <div className="submit-area">
              {showSubmitButton && (
                <Button color="primary" onClick={this.submitOrder}>
                  Submit Order
                </Button>
              )}
              <div>
                <Link to="/Purchase/ShoppingCart">Edit Order</Link>
              </div>
            </div>
          </Col>
        </Row>
        <OrderSubmissionModal isOpen={!showSubmitButton} />
      </Container>
    );
  }
}
